<app-plain-table
  [isLoading]="isLoading()"
  [columns]="columns()"
  [data]="data()">
  <ng-template #actions let-item>
    <div class="flex gap-2">
      <ui-button [disabled]="isLoading()" (click)="view.emit(item)" size="sm">
        <fa-icon [icon]="faEye" />
        View
      </ui-button>
      <ui-button
        [disabled]="isLoading() || deleteDisabled()"
        (click)="delete.emit(item)"
        size="sm"
        [outline]="true">
        <fa-icon [icon]="faTrash" />
        Delete
      </ui-button>
    </div>
  </ng-template>
</app-plain-table>
